export default {
  EDUCATOR_URL: process.env.NEXT_PUBLIC_EDUCATOR_URL,
  GN_ASSETS_BASE_URL: process.env.NEXT_PUBLIC_GN_ASSETS_BASE_URL,
};
